export const filterData = (data, target) => {
  return data.filter((item) => {
    return Object.keys(target).every((key) => {
      return item[key]?.toString().toLowerCase().includes(target[key].toString().toLowerCase());
    });
  });
};

export const sortData = (data, key, direction) => {
  return data.sort((a, b) => {
    if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
    if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
    return 0;
  });
};

export const sliceData = (data, start, end) => {
  return data.slice(start, end);
};

export const getSortedAndSlicedData = (dataState, sortConfig, page, rowsPerPage) => {
  const sortedData = sortConfig.key ? sortData([...dataState], sortConfig.key, sortConfig.direction) : dataState;
  if (rowsPerPage === -1) return sortedData;
  return sortedData.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
};

export const handleSort = (column, setSortConfig) => {
  setSortConfig((prevConfig) => ({
    key: column,
    direction: prevConfig.key === column && prevConfig.direction === 'asc' ? 'desc' : 'asc',
  }));
};
